import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { resolve, reject } from 'q';

import { environment } from "../../environments/environment";
import { encode } from 'punycode';
import { BehaviorSubject } from 'rxjs';
// import { AlertService } from './alert.service';

@Injectable()
export class FormService {
    constructor(private http: HttpClient) { };
    private il = new BehaviorSubject<string>('');
    inventory = this.il.asObservable();

    public getQuestionTypeList() {
        const getQuestionTypeListObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/question/type`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getQuestionTypeListObservable; 
    } // prifle end*/
    public getQuestionTypeOne(type) {
        const getQuestionTypeOneObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/question/type/${type.id}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getQuestionTypeOneObservable; 
    } // prifle end*/
    public updateQuestionTypeOne(type){
        const updateQuestionTypeOneObservable = new Observable(observer => {
            this.http.put(`${environment.API_HOST}/question/type/${type.id}`,type)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateQuestionTypeOneObservable;  
    }
    public deleteQuestionTypeOne(type){
        const deleteQuestionTypeOneCompanyObservable = new Observable(observer => {
            this.http.delete(`${environment.API_HOST}/question/type/${type.id}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return deleteQuestionTypeOneCompanyObservable;  
    }
    public newQuestionTypeOne(type){
        const newQuestionTypeOneObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/question/type/`,type)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return newQuestionTypeOneObservable;  
    }

    public getQuestionList() {
        const getQuestionListObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/question/`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getQuestionListObservable; 
    } // prifle end*/
    public getQuestionOne(question) {
        const getQuestionOneObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/question/${question.id}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getQuestionOneObservable; 
    } // prifle end*/
    public updateQuestionOne(question){
        const updateQuestionOneObservable = new Observable(observer => {
            this.http.put(`${environment.API_HOST}/question/${question.id}`,question)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateQuestionOneObservable;  
    }
    public deleteQuestionOne(question){
        const deleteQuestionOneCompanyObservable = new Observable(observer => {
            this.http.delete(`${environment.API_HOST}/question/${question.id}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return deleteQuestionOneCompanyObservable;  
    }
    public newQuestionOne(question){
        const newQuestionOneObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/question/`,question)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return newQuestionOneObservable;  
    }


    public getFormList() {
        const getFormListObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/form`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getFormListObservable; 
    } // prifle end*/
    public getFormOne(form) {
        const getFormOneObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/form/${form}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getFormOneObservable; 
    } // prifle end*/
    public updateFormOne(form){
        const updateFormOneObservable = new Observable(observer => {
            this.http.put(`${environment.API_HOST}/form/${form.token}`,form)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateFormOneObservable;  
    }
    public deleteFormOne(form){
        const deleteFormOneObservable = new Observable(observer => {
            this.http.delete(`${environment.API_HOST}/form/${form.token}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return deleteFormOneObservable;  
    }
    public newFormOne(form){
        const newFormOneObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/form/`,form)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return newFormOneObservable;  
    }

} // class

// Mon Apr 15 2019 13:33:13 GMT-0600